import { GetterTree } from 'vuex';
import { LocationState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<LocationState, RootState> = {
  availableCities: state => {
    return state.availableCities;
  },
  availableCampuses: state => {
    return state.availableCampuses;
  },
};

export default getters;
